var map = {
	"./123.png": 94595,
	"./absa.png": 14053,
	"./absa_icon.png": 24220,
	"./absa_icon_transparent.png": 283,
	"./absa_iconjiuhjhu.png": 98621,
	"./absakjjuhj.png": 45824,
	"./appletree.png": 77363,
	"./appletree_icon.png": 31819,
	"./appletree_icon1.png": 86074,
	"./appletree_icon_transparent1.png": 73803,
	"./aunipay.png": 6854,
	"./aunipay_icon.png": 40560,
	"./awalletPaymentplug.png": 56323,
	"./awalletPaymentplug_icon.png": 39483,
	"./default.png": 620,
	"./default_icon.png": 88138,
	"./default_icon1.png": 32537,
	"./default_iconDark.png": 53490,
	"./default_icon_old.png": 360,
	"./default_iconn.png": 41438,
	"./dreamzwallet.png": 99305,
	"./dreamzwallet_icon.png": 22685,
	"./dreamzwallet_icon_transparent2.png": 38674,
	"./dreamzwallet_icon_transparent3.png": 36539,
	"./dreamzwallet_icon_transparent4.png": 54884,
	"./dreamzwallet_icon_transparent5.png": 11181,
	"./dreamzwallet_icon_transparent6.png": 29558,
	"./dreamzwallet_icon_transparent7.png": 9535,
	"./dreamzwallet_icon_transparent9.png": 41489,
	"./dreamzwalletz_icon.png": 67279,
	"./mego.png": 59519,
	"./onetap.png": 12816,
	"./onetap_icon.png": 66286,
	"./takapaysa.png": 82838,
	"./takapaysa_icon.png": 49408,
	"./transactWorldUK.png": 8813,
	"./transactWorldUK_icon.png": 34737,
	"./unipay.png": 70339,
	"./unipay1.png": 94658,
	"./unipay12.png": 60010,
	"./unipay_icon.png": 81083,
	"./unipay_iconDark.png": 37343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96888;